<avi-card class="licensing-get-started-card">
    <avi-card_header>
        <div class="licensing-get-started-card__header">
            <cds-icon
                shape="certificate"
                size="24"
                status="success"
            ></cds-icon>
            <div class="licensing-get-started-card__header-text">
                {{ l10nKeys.getStartedLabel | vtranslate }}
            </div>
        </div>
    </avi-card_header>
    <avi-card_body>
        <div class="licensing-get-started-card__options-container">
            <!-- Cloud Licensing Section -->
            <div class="licensing-get-started-card__section">
                <clr-radio-container class="licensing-get-started-card__clr-radio-container">
                    <clr-radio-wrapper>
                        <input
                            type="radio"
                            clrRadio
                            name="licensingType"
                            [value]="licensingTypes.ENTERPRISE_WITH_CLOUD_SERVICES"
                            [checked]="(tierInUse$ | async) === licensingTypes.ENTERPRISE_WITH_CLOUD_SERVICES"
                            (change)="onLicensingTypeChange(licensingTypes.ENTERPRISE_WITH_CLOUD_SERVICES)"
                            [disabled]="isTierChangeInProgress"
                            id="cloud-licensing"
                        />
                        <label for="cloud-licensing">
                            <h4>{{ l10nKeys.cloudLicensingLabel | vtranslate }}</h4>
                        </label>
                    </clr-radio-wrapper>
                </clr-radio-container>
                <div class="licensing-get-started-card__message-text">
                    {{ l10nKeys.cloudLicensingDescription | vtranslate }}
                </div>
                <ng-container *ngrxLet="tierInUse$ as tierInUse">
                    <cds-button
                        (click)="handleConnectToCloudLicensing()"
                        (keydown.enter)="handleConnectToCloudLicensing()"
                        [disabled]="tierInUse !== licensingTypes.ENTERPRISE_WITH_CLOUD_SERVICES"
                        [loading]="busy || isTierChangeInProgress"
                        id="connect-to-cloud-licensing"
                        size="md"
                        status="primary"
                    >
                        {{ l10nKeys.connectToCloudLicensingLabel | vtranslate | uppercase }}
                    </cds-button>
                </ng-container>
            </div>

            <!-- Divider -->
            <div class="licensing-get-started-card__divider">
                <div class="licensing-get-started-card__divider-line"></div>
                <div class="licensing-get-started-card__divider-text">
                    {{ l10nKeys.orLabel | vtranslate }}
                </div>
                <div class="licensing-get-started-card__divider-line"></div>
            </div>

            <!-- On-prem Licensing Section -->
            <div class="licensing-get-started-card__section">
                <clr-radio-container class="licensing-get-started-card__clr-radio-container">
                    <clr-radio-wrapper>
                        <input
                            type="radio"
                            clrRadio
                            name="licensingType"
                            [value]="licensingTypes.ENTERPRISE"
                            [checked]="(tierInUse$ | async) === licensingTypes.ENTERPRISE"
                            (change)="onLicensingTypeChange(licensingTypes.ENTERPRISE)"
                            [disabled]="isTierChangeInProgress"
                            id="on-prem-licensing"
                        />
                        <label for="on-prem-licensing">
                            <h4>{{ l10nKeys.onPremLicensingServiceLabel | vtranslate }}</h4>
                        </label>
                    </clr-radio-wrapper>
                </clr-radio-container>
                <div class="licensing-get-started-card__message-text">
                    {{ l10nKeys.onPremLicensingServiceDescription | vtranslate }}
                </div>
                <ng-container *ngrxLet="tierInUse$ as tierInUse">
                    <cds-button
                        (click)="handleUseOnPremLicensingService()"
                        (keydown.enter)="handleUseOnPremLicensingService()"
                        [disabled]="tierInUse !== licensingTypes.ENTERPRISE"
                        [loading]="isTierChangeInProgress"
                        [outline]="true"
                        id="on-boarding-instruction"
                        size="md"
                        status="primary"
                    >
                        {{ l10nKeys.onBoardingInstructionLabel | vtranslate | uppercase }}
                    </cds-button>
                </ng-container>
            </div>
        </div>
    </avi-card_body>
</avi-card>
